import { render, staticRenderFns } from "./AdditionalNutritional.vue?vue&type=template&id=07fbb380&"
import script from "./AdditionalNutritional.vue?vue&type=script&lang=js&"
export * from "./AdditionalNutritional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports